
import toLower from 'lodash/toLower';
import deburr from 'lodash/deburr';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { I18nMixin } from '../../../mixins';
import { ISEOButtonDefaultI18n, ISEOButtonOverrideI18n } from '../types';

@Component
export default class WLButton extends Mixins(I18nMixin) {
  get loweredDomain() {
    return toLower(this.domain);
  }

  get computedDomain() {
    return deburr(this.loweredDomain);
  }

  get label() {
    return `${this.translations.diagnosis} ${this.$t(this.loweredDomain)}`;
  }

  public defaultI18n!: ISEOButtonDefaultI18n;

  @Prop()
  public overrideI18n!: ISEOButtonOverrideI18n;

  @Prop()
  private domain!: string;

  public created() {
    this.defaultI18n = {
      diagnosis: this.$t('components_plugin.SEOZone.diagnosis'),
    };
  }
}
